import {
  getBankList,
  queryOrderStatus,
  signWithhold,
  syncUserInfo,
  templateConfig,
} from "../../api/url";

const state = {
  userInfo: {
    phone: "",
    name: "",
    idcardNumber: "",
    certValidityType: 0,
    certBeginDate: "",
    certEndDate: "",
  },
  thirdOrderId: "", // 订单号 从router参数adid获取
  actId: "", // 活动id 从router参数actId获取
  pageId: "", // 页面id 从router参数pageId获取
  pageCustomConfig: {},
  loading: false,
  error: null,
};

const mutations = {
  SET_USER_INFO(state, userInfo) {
    state.userInfo = { ...state.userInfo, ...userInfo };
  },
  UPDATE_USER_FIELD(state, { field, value }) {
    state.userInfo[field] = value;
  },
  SET_PAGE_INFO(state, { thirdOrderId, actId, pageId }) {
    thirdOrderId && (state.thirdOrderId = thirdOrderId);
    actId && (state.actId = actId);
    pageId && (state.pageId = pageId);
  },
  SET_PAGE_CONFIG(state, config) {
    state.pageCustomConfig = config;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  CLEAR_USER_INFO(state) {
    state.userInfo = {
      phone: "",
      name: "",
      idcardNumber: "",
    };
  },
};

const actions = {
  // 初始化页面信息
  async initPageInfo({ commit }, { thirdOrderId, actId }) {
    const pageInfo = {
      thirdOrderId,
      actId,
    };
    commit("SET_PAGE_INFO", pageInfo);
    const res = await templateConfig({ actId: pageInfo.actId });
    if (res.code === 0 && res.data && res.data.info) {
      commit("SET_PAGE_CONFIG", res.data.info);
      commit("SET_PAGE_INFO", { pageId: res.data.pageId });
    }
  },
  // 获取银行列表
  getBankList({ commit }) {
    return getBankList({
      actId: state.actId,
      phone: state.userInfo.phone,
    });
  },
  // 查询订单状态 手机号页面和银行卡页面共用
  async fetchOrderInfo({ commit }) {
    commit("SET_LOADING", true);
    try {
      if (!state.thirdOrderId) return;
      const res = await queryOrderStatus({ thirdOrderId: state.thirdOrderId });
      if (res.code === 0 && res.data) {
        const data = res.data;
        // 有成功页跳转
        if (data.paySuccessUrl) {
          // 支付成功且未退款，跳支付成功页
          window.location.replace(data.paySuccessUrl);
        } else {
          commit("SET_USER_INFO", data);
          commit("SET_ERROR", null);
        }
      }
    } catch (error) {
      commit("SET_ERROR", error.message);
    } finally {
      commit("SET_LOADING", false);
    }
  },
  // 同步用户信息
  async updateUserInfo({ commit }, userInfo) {
    commit("SET_LOADING", true);
    try {
      // 同步用户信息接口调用
      const response = await syncUserInfo({
        actId: state.actId,
        thirdOrderId: state.thirdOrderId,
        ...state.userInfo,
        ...userInfo,
      });
      if (response.code == 0) {
        commit("SET_USER_INFO", userInfo);
        commit("SET_ERROR", null);
      }
    } catch (error) {
      commit("SET_ERROR", error.message);
    } finally {
      commit("SET_LOADING", false);
    }
  },

  // 签约绑卡
  async signBank({ commit }, { code }) {
    commit("SET_LOADING", true);
    try {
      // 调用签约绑卡接口
      const response = await signWithhold({
        actId: state.actId,
        thirdOrderId: state.thirdOrderId,
        code,
        landUrl: window.location.href,
        phone: state.userInfo.phone,
        name: state.userInfo.name,
        idcardNumber: state.userInfo.idcardNumber,
      });
      console.log("🚀 ~ response.data:", response.data);
      if (response.code == 0 && response.data) {
        commit("SET_ERROR", null);
        return;
      } else {
        throw new Error(response.message || "签约绑卡失败");
      }
    } catch (error) {
      commit("SET_ERROR", error.message);
    } finally {
      commit("SET_LOADING", false);
    }
  },

  updateUserField({ commit }, { field, value }) {
    commit("UPDATE_USER_FIELD", { field, value });
  },

  logout({ commit }) {
    commit("CLEAR_USER_INFO");
  },
};

const getters = {
  getUserInfo: (state) => state.userInfo,
  getUserPhone: (state) => state.userInfo.phone,
  getUserName: (state) => state.userInfo.name,
  getIdNumber: (state) => state.userInfo.idNumber,
  isLoading: (state) => state.loading,
  getError: (state) => state.error,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/withholdUser.js